type Props = { onClick?: () => void; size?: number; as?: 'button' | 'span' }

/** Text wordmark with the accent square — replaces the gradient logo. */
export default function Wordmark({ onClick, size = 22, as = 'button' }: Props) {
  const inner = (
    <>
      softmaze
      <span className="wordmark__dot" aria-hidden />
    </>
  )
  if (as === 'span' || !onClick) {
    return (
      <span className="wordmark" style={{ fontSize: size }}>
        {inner}
      </span>
    )
  }
  return (
    <button
      type="button"
      className="wordmark"
      onClick={onClick}
      aria-label="Softmaze — home"
      style={{ fontSize: size, background: 'none', border: 0, padding: 0, cursor: 'pointer' }}
    >
      {inner}
    </button>
  )
}
